import React from 'react';
import loadable from '@wix/yoshi-flow-editor/loadable';
import Loader from '../../../common/components/loader';

export const WixRicosViewerLazy = loadable(() => /* webpackChunkName: "ricos-viewer" */ import('@wix/ricos-viewer'), {
  resolveComponent: (components: any) => components.WixRicosViewer,
  fallback: <Loader />,
});
